module.exports = __webpack_public_path__ + "static/media/1.acb4a08c.jpeg";